import { useEffect, useState, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { ConclusionLlenadaSEInterface } from "../../../../../interfaces/ConclusionLlenadaSEInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Checkbox, Label, Textarea, TextInput } from "flowbite-react";
import SkyClear from "../../../../../img/SkyClear.png";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import { ApiKeyMaps } from "../../../../../apis/apis";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const EvaluacionPatrimonial1CrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "EVALUACIÓN PATRIMONIAL 1";
  const { control, reset, handleSubmit, getValues } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);
  const [showOtherInput, setShowOtherInput] = useState(false);

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const imageUrl = `http://localhost:8000/storage/evaluados/photos/${evaluadosList_id}/Croquis.png`;

  const buildIntegrantesText = () => {
    const hijos = Number(queryEvaluado.data?.cuantos_hijos) || 0;
    const edades = [
      queryEvaluado.data?.edad_hijo1,
      queryEvaluado.data?.edad_hijo2,
      queryEvaluado.data?.edad_hijo3,
      queryEvaluado.data?.edad_hijo4,
    ].filter((edad) => edad);

    let texto = `${hijos} hijo${hijos !== 1 ? "s" : ""}`;

    if (edades.length > 0) {
      texto += ` de ${edades.join(", ")} años`;
    }

    return texto;
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const resetFormData = () => {
    const emptyFormData = {
      visitDate: "",
      name: "",
      rfc: "",
      sex: "",
      civilStatus: "",
      education: "",
      birthDate: "",
      curp: "",
      company: "",
    };
    setImages([""]);
    localStorage.removeItem("images");
  };

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...images];
        newImages[index] = reader.result as string;
        setImages(newImages);

        localStorage.setItem("images", JSON.stringify(newImages));
      };
      reader.readAsDataURL(file);
    }
  };

  const addImageBox = () => {
    setImages([...images, ""]);
    setNotes([...notes, ""]);
  };

  const removeImage = (index: number) => {
    const updatedImages = images.filter((_, i) => i !== index);
    const updatedNotes = notes.filter((_, i) => i !== index);
    setImages(updatedImages);
    setNotes(updatedNotes);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const handleNoteChange = (
    index: number,
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = event.target.value;
    setNotes(updatedNotes);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const mutateFechaSE = useMutationData({
    url: `/fecha-socioeconomica/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-socioeconomica"],
  });

  const mutateEvaluacionSE = useMutationData({
    url: `/conclusionllenada_se/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_se"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
        lugar_nacimiento: queryEvaluado.data.lugar_nacimiento || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }
    const renderPage1 = () => (
      <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-900"}`}>
        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_evaluacionse" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              FECHA:
            </Label>
            <Controller
              name="fecha_evaluacionse"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="fecha_evaluacionse"
                  type="date"
                  placeholder="Seleccionar fecha"
                  {...field}
                  className={`w-32 ${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
                />
              )}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              NOMBRE:
            </Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
              className={`${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
            />
          </div>
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              RFC:
            </Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
              className={`${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad" className={`font-semibold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              EDAD:
            </Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
              className={`text-9xl font-bold ${isDarkMode ? "text-gray-600" : "text-blue-500"} ${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              SEXO:
            </Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
              className={`${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              ESTADO CIVIL:
            </Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
              className={`${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              ESCOLARIDAD:
            </Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
              className={`${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className={`w-32 ${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              CURP:
            </Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
              className={`${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              EMPRESA:
            </Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
              className={`${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
            />
          </div>
        </div>
      </div>
    );

    const renderPage2 = () => (
      <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-800 text-white" : "bg-gray-50"}`}>

        <div className={`p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
          <h2 className="font-bold text-xl">EVALUACIÓN DE PATRIMONIAL 1</h2>
        </div>
  
        {/* Tabla */}
        <div className="w-full overflow-x-auto">
          <table className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border-2 border-gray-500"}`}>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
                <th
                  colSpan={3}
                  className={`py-3 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                >
                  CUESTIONARIO INVESTIGACIÓN SOCIOECONÓMICA
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Estado Civil
                </th>
                <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  En caso de estar casado, indique el régimen matrimonial
                </th>
                <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuántos años tiene de casado?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <textarea
                    className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                    value={
                      queryEvaluado.data?.estado_civil
                        ? queryEvaluado.data.estado_civil
                            .charAt(0)
                            .toUpperCase() +
                          queryEvaluado.data.estado_civil.slice(1)
                        : ""
                    }
                    placeholder="Estado Civil"
                    disabled={true}
                  />
                </td>
                <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="regimen_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="regimen_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Régimen..."
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="anioscasado_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="anioscasado_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Cuantos años?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-3 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuántos hijos tiene y que edades tienen?
                </th>
                <th className={`py-3 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuántos dependientes económicos tiene y quiénes son?
                </th>
                <th className={`py-3 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Empresa en la que labora, antigüedad y a qué área pertenece
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="integrantes"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="integrantes"
                        value={buildIntegrantesText()}
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Integrantes"
                        readOnly
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="numdependientes_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="numdependientes_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Número de dependientes"
                      />
                    )}
                  />
                  <Controller
                    name="quienesdependen_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="quienesdependen_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Quienes?"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <textarea
                    id="describe"
                    value={`${
                      queryEvaluado.data?.empresa_id?.nombre || "" || ""
                    } con ${
                      queryEvaluado.data?.antiguedad || ""
                    } de antigüedad, en el área de ${
                      queryEvaluado.data?.puesto || ""
                    }
                    `}
                    className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                    placeholder="Descripción"
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Fecha de ingreso a la empresa en la que actualmente labora
                </th>
                <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuenta con familiares laborando en la empresa donde está
                  actualmente?
                </th>
                <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cómo se enteró del empleo?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="fechaingreso"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="fechaingreso"
                        value={`Ingresó el ${
                          queryEvaluado.data?.fecha_ingreso
                            ? new Date(
                                queryEvaluado.data.fecha_ingreso
                              ).toLocaleDateString("es-ES")
                            : ""
                        }
                        `}
                        disabled={true}
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Razón de identificación"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="cuentaconfamiliares_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="cuentaconfamiliares_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Cuenta con familiares en la empresa?"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="enterovacante_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="enterovacante_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Como se enteró?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
  
        <div className="w-full overflow-x-auto">
          <table className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
                <th colSpan={3} className={`py-3 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  CUESTIONARIO PARA INVESTIGACIÓN SOCIOECONÓMICA
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cómo llego y quien le recomendó laborar en esa empresa?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuánto asciende su ingreso mensual familiar y como este
                  compuesto, incluyendo el de su esposa(o) de ser el caso, así
                  como ingresos extras por conceptos de alquiler u otros?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuáles son sus egresos mensuales familiares y como este
                  compuesto, incluyendo el de su esposa de ser el caso, incluyendo
                  deudas, gastos del hogar, diversiones etc.?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="comollego_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="comollego_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        aria-label="comollego_se"
                        placeholder="¿Cómo llegó?"
                      />
                    )}
                  />
                  <Controller
                    name="recomendo_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="recomendo_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        aria-label="recomendo_se"
                        placeholder="¿Quien lo recomendó?"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="ingresomensual_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="ingresomensual_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        aria-label="ingresomensual_se"
                        placeholder="Ingreso mensual familiar"
                      />
                    )}
                  />
                  <Controller
                    name="compuestopor_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="compuestopor_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        aria-label="compuestopor_se"
                        placeholder="Compuesto por..."
                      />
                    )}
                  />
                  <Controller
                    name="ingresoesposa_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="ingresoesposa_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        aria-label="ingresoesposa_se"
                        placeholder="Ingreso esposa(o)"
                      />
                    )}
                  />
                  <Controller
                    name="ingresosextra_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="ingresosextra_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        aria-label="ingresoesposa_se"
                        placeholder="Ingresos extra"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="egresosfam_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="egresosfam_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Egresos mensuales familiares"
                      />
                    )}
                  />
                  <Controller
                    name="compuestosde_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="compuestosde_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Como estan compuestos?"
                      />
                    )}
                  />
                  <Controller
                    name="esposaegreso_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="esposaegreso_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Esposa egresos"
                      />
                    )}
                  />
                  <Controller
                    name="deudasascienden1_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="deudasascienden1_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Deudas..."
                      />
                    )}
                  />
                  <Controller
                    name="gastosaprox_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="gastosaprox_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Gastos aproximados"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿A cuánto ascienden sus deudas?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Mencione las cuentas bancarias de las que Usted es titular?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuántos inmuebles propios o en sociedad posee?, descríbalos,
                  ¿Con que títulos de propiedad cuenta y como los adquirió?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="deudasascienden2_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="deudasascienden2_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Deudas..."
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="cuentasbancarias_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="cuentasbancarias_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Cuentas Bancarias"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="cuantosinmuebles_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="cuantosinmuebles_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Cuantos Inmuebles?"
                      />
                    )}
                  />
                  <Controller
                    name="titulospropiedad_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="titulospropiedad_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Con que titulos cuenta?"
                      />
                    )}
                  />
                  <Controller
                    name="comoadquirio1_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="comoadquirio1_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Como los adquirió?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuántos vehículos posee?, descríbalos, ¿Con que títulos de
                  propiedad cuenta y como los adquirió?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuenta con procesos penales o procedimientos administrativos?,
                  en caso de que si, descríbalos
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Escriba el domicilio donde habita actualmente?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="cuantosvehiculos_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="cuantosvehiculos_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Cuántos?"
                      />
                    )}
                  />
                  <Controller
                    name="descripcionvehiculos"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="descripcionvehiculos"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Descripción..."
                      />
                    )}
                  />
                  <Controller
                    name="titulosvehiculos_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="titulosvehiculos_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Con que titulos cuenta?"
                      />
                    )}
                  />
                  <Controller
                    name="comoadquirio2_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="comoadquirio2_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Como los adquirio?"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="procesospenales_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Controller
                        name="procesospenales_se"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <select
                            {...field}
                            id="procesospenales_se"
                            className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                          >
                            <option value="">Elige</option>
                            <option value="true">Si</option>
                            <option value="false">No</option>
                          </select>
                        )}
                      />
                    )}
                  />
                  <Controller
                    name="descripcionpenales_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="descripcionpenales_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Descripción..."
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="domicilio"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="domicilio"
                        value={`${queryEvaluado.data?.calle || ""}, ${
                          queryEvaluado.data?.numero_exterior || ""
                        }, ${queryEvaluado.data?.colonia || ""}, ${
                          queryEvaluado.data?.codigo_postal || ""
                        }, ${queryEvaluado.data?.municipio || ""}, ${
                          queryEvaluado.data?.estado || ""
                        }, ${queryEvaluado.data?.pais || ""}`}
                        disabled={true}
                        className={`w-full h-[150px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Domicilio..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>

        <div className="w-full overflow-x-auto">
          <table className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Anote las direcciones
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Anote dos referencias vecinales
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Qué hace en sus tiempos libres?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="anotedirecciones_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="anotedirecciones_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Direcciones..."
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="referenciavecinal1_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="referenciavecinal1_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Referencia..."
                      />
                    )}
                  />
                  <Controller
                    name="referenciavecinal2_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="referenciavecinal2_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Referencia..."
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="tiempolibre_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="tiempolibre_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Que hace en su tiempo libre?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Practica algún deporte? (Si/No) ¿Cuál?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿A que religión pertenece?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cómo considera su estado de salud y por qué?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="practicadeporte_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="practicadeporte_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="true">Si</option>
                        <option value="false">No</option>
                      </select>
                    )}
                  />
                  <Controller
                    name="cualdeporte_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="cualdeporte_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Cual?"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="religionpertenece_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="religionpertenece_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Que religión?"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="estadosalud_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="estadosalud_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Estado de salud..."
                      />
                    )}
                  />
                  <Controller
                    name="derivado_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="derivado_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Porque?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
  
        <div className="w-full overflow-x-auto">
          <table
            className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}
            style={{ tableLayout: "fixed" }}
          >
            {/* Encabezado principal */}
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
                <th colSpan={3} className={`py-3 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  CUESTIONARIO PARA INVESTIGACIÓN SOCIOECONÓMICA
                </th>
              </tr>
            </thead>
  
            {/* Encabezado secundario */}
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th colSpan={3} className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Elabore un croquis de su domicilio actual, entre que calles y
                  referencias
                </th>
              </tr>
            </thead>
          </table>
        </div>
  
        {/* Croquis */}
        <div className="mt-4 mb-4 w-full">
          <div className="flex justify-center mt-2">
            <img
              src={imageUrl}
              alt="Croquis"
              className={`w-full max-w-[800px] h-auto rounded-lg border-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
            />
          </div>
        </div>
  
        <div className="w-full overflow-x-auto">
          <table className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}>
            {/* Preguntas sobre el inmueble */}
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuánto tiempo tiene viviendo en ese inmueble?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿A quién pertenece el inmueble donde habita actualmente?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cómo es la relación que lleva con sus vecinos?
                </th>
              </tr>
            </thead>
  
            {/* Textareas para las preguntas sobre el inmueble */}
            <tbody>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="tiempoviviendo_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="tiempoviviendo_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Tiempo en el inmueble"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="inmuebleperteece_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="inmuebleperteece_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Propietario del inmueble"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="relacionvecinos_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="relacionvecinos_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Relación con vecinos"
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
  
            {/* Preguntas sobre hábitos */}
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Fuma, ¿Cuántos cigarros al día aproximadamente?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Consume bebidas alcohólicas, ¿Con qué frecuencia y cuándo fue la
                  última vez?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Ha consumido o consume algún tipo de droga?
                </th>
              </tr>
            </thead>
  
            {/* Textareas para las preguntas sobre hábitos */}
            <tbody>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="fuma_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="fuma_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="true">Si</option>
                        <option value="false">No</option>
                      </select>
                    )}
                  />
                  <Controller
                    name="cuantofuma_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="cuantofuma_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Cantidad de cigarros"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="toma_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="toma_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="true">Si</option>
                        <option value="false">No</option>
                      </select>
                    )}
                  />
                  <Controller
                    name="cuantotoma_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="cuantotoma_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Con qué frecuencia?"
                      />
                    )}
                  />
                  <Controller
                    name="ultimavez_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="ultimavez_se"
                        type="date"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Cuando fue la ultima vez?"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="consumedrogas_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="consumedrogas_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="true">Si</option>
                        <option value="false">No</option>
                      </select>
                    )}
                  />
                </td>
              </tr>
            </tbody>
  
            {/* Preguntas sobre demandas laborales */}
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Ha interpuesto demandas laborales?
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  En caso afirmativo, explique los motivos
                </th>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿En qué año fue interpuesta?
                </th>
              </tr>
            </thead>
  
            {/* Textareas para las preguntas sobre demandas laborales */}
            <tbody>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="inpuestodemanda_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="inpuestodemanda_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Demandas laborales"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="motivodemanda_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="motivodemanda_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Motivos de las demandas"
                      />
                    )}
                  />
                </td>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="aniodemanda_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        {...field}
                        id="aniodemanda_se"
                        type="date"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Año de la demanda"
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <div className="w-full overflow-x-auto">
          <table
            className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}
            style={{ tableLayout: "fixed" }}
          >
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
                <th className={`py-3 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  INFORMACIÓN DE CRÉDITOS
                </th>
              </tr>
            </thead>
  
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-400 text-black"}`}></tr>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Tienes algún crédito?
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="tienecredito_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="tienecredito_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="true">Si</option>
                        <option value="false">No</option>
                      </select>
                    )}
                  />
                </td>
              </tr>
            </tbody>
  
            {/* Responsabilidad */}
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-400 text-black"}`}></tr>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Qué tipo de crédito es?
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="tipocredito_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <div>
                        <select
                          {...field}
                          id="tipocredito_se"
                          className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                          onChange={(e) => {
                            field.onChange(e);
                            setShowOtherInput(e.target.value === "");
                          }}
                        >
                          <option value="">Elige</option>
                          <option value="Automotriz">Automotriz</option>
                          <option value="Hipotecario">Hipotecario</option>
                          <option value="Tarjeta bancaria o departamental">
                            Tarjeta bancaria o departamental
                          </option>
                          <option value="Infonavit">Infonavit</option>
                          <option value="Caja de Ahorro">Caja de Ahorro</option>
                          <option value="Nómina">Nómina</option>
                          <option value="">Otro Especifique</option>
                        </select>
  
                        {showOtherInput && (
                          <input
                            type="text"
                            className={`w-full border rounded-md p-2 mt-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                            placeholder="Especifique"
                            onChange={(e) => {
                              field.onChange(e.target.value);
                            }}
                          />
                        )}
                      </div>
                    )}
                  />
                </td>
              </tr>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Automóvil (es) que está pagando
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="autopaga_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="autopaga_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Auto..."
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Pago (s) Mensual (es)
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="pagomensuales_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="pagomensuales_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Pago..."
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Tarjetas de crédito que está pagando
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="tarjetaspaga_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="tarjetaspaga_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Tarjetas..."
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  Pago mensual (total) a tarjetas
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="pagomensualtarjetas_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="pagomensualtarjetas_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Pago..."
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Tiene adeudos?
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="tieneadeudoscredito_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="tieneadeudoscredito_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="true">Si</option>
                        <option value="false">No</option>
                      </select>
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Con qué institución tiene el crédito hipotecario?
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="institucioncredito_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="institucioncredito_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Con cual?..."
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuánto paga?
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="cuantopagacredito_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="cuantopagacredito_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Cuánto?..."
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Tiene crédito FONACOT?
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="tienecreditofonacot_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="tienecreditofonacot_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="true">Si</option>
                        <option value="false">No</option>
                      </select>
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Cuánto paga?
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="cuantopagafonacot_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="cuantopagafonacot_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="¿Cuánto?"
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Tiene retraso en alguno de los créditos?
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="retrasocredito_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="retrasocredito_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="true">Si</option>
                        <option value="false">No</option>
                      </select>
                    )}
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
                <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  ¿Estás en buró de crédito? Especifique
                </th>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="burocredito_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="burocredito_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="true">Si</option>
                        <option value="false">No</option>
                      </select>
                    )}
                  />
                  <Controller
                    name="motivoburo_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="motivoburo_se"
                        {...field}
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Especifique..."
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <div className="w-full overflow-x-auto">
          <table className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
                <th className={`py-3 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  DISTRIBUCIÓN DE GASTOS
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <span>
                    <strong>INGRESOS ESTIMADOS EN FAMILIA:</strong> $
                    <Controller
                      name="ingresomensual_se"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <input
                          id="ingresomensual_se"
                          {...field}
                          type="text"
                          className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                          placeholder="$0"
                        />
                      )}
                    />
                    .00, / $
                    <Controller
                      name="ingresomensual2_se"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <input
                          id="ingresomensual2_se"
                          {...field}
                          type="text"
                          className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                          placeholder="Ocasión responsabilidad"
                        />
                      )}
                    />
                    .00 ingreso de su pareja y / $
                    <Controller
                      name="ingresoesposa_se"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <input
                          id="ingresoesposa_se"
                          {...field}
                          type="text"
                          className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                          placeholder="Ocasión responsabilidad"
                        />
                      )}
                    />
                    .00 ingreso del evaluado.
                  </span>
                </td>
              </tr>
            </thead>
          </table>
        </div>
        {/* Tabla de distribución mensual de gastos */}
        <div className="w-full overflow-x-auto">
          <table className={`table-auto border-collapse w-full ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}>
            {/* Header */}
            <thead>
              <tr>
                <th
                  className={`border px-4 py-2 text-center font-semibold ${isDarkMode ? "bg-blue-800 text-white border-gray-600" : "bg-gray-100 text-gray-700 border-gray-300"}`}
                  colSpan={2}
                >
                  DISTRIBUCION MENSUAL DE GASTOS
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Filas */}
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Alimentación
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastoalimentacion_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastoalimentacion_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Vestido y Calzado
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastovestido_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastovestido_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Gasolina
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastogasolina_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastogasolina_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Transporte
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastotransporte_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastotransporte_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Teléfono
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastotelefono_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastotelefono_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Diversiones
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastodiversiones_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastodiversiones_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Autofinanciamiento
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastoautofinanciamiento_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastoautofinanciamiento_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Otros
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastootros1_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastootros1_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <br />
          </div>
          <table className={`table-auto border-collapse w-full ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}>
            <tbody>
              {/* Filas */}
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Hipoteca
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastohipoteca_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastohipoteca_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Renta
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastorenta_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastorenta_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Colegiaturas
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastocolegiaturas_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastocolegiaturas_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Servicios
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastoservicios_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastoservicios_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Deudas
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastodeudas_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastodeudas_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Inversiones
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastoinversiones_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastoinversiones_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Pensión Alimenticia
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastopension_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastopension_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Otros
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastootros2_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastootros2_se"
                        type="numeric"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$1,000"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className={`border px-4 py-2 font-bold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  Total
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="gastototal_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="gastototal_se"
                        type="text"
                        className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="$0.00"
                        value={[
                          "gastoalimentacion_se",
                          "gastovestido_se",
                          "gastogasolina_se",
                          "gastotransporte_se",
                          "gastotelefono_se",
                          "gastodiversiones_se",
                          "gastoautofinanciamiento_se",
                          "gastootros1_se",
                          "gastohipoteca_se",
                          "gastorenta_se",
                          "gastocolegiaturas_se",
                          "gastoservicios_se",
                          "gastodeudas_se",
                          "gastoinversiones_se",
                          "gastopension_se",
                          "gastootros2_se",
                        ]
                          .map((name) => getValues(name) || 0)
                          .reduce((acc, value) => acc + parseFloat(value), 0)
                          .toFixed(2)}
                        readOnly
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="w-full overflow-x-auto">
          <table className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
                <th
                  colSpan={6}
                  className={`py-3 px-4 border-b text-left text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                >
                  ESCOLARIDAD
                </th>
              </tr>
            </thead>
            <thead className={`${isDarkMode ? "bg-gray-600" : "bg-gray-100"}`}>
              <tr>
                <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  NIVEL
                </th>
                <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  NOMBRE DE LA INSTITUCIÓN
                </th>
                <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  CIUDAD
                </th>
                <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  AÑOS CURSADOS
                </th>
                <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  PERIODO
                </th>
                <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  CERTIFICADO
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Primaria */}
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  PRIMARIA
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="nombreprimaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="nombreprimaria_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Institución"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="ciudadprimaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="ciudadprimaria_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Ciudad"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="aniosprimaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="aniosprimaria_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Años"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="periodoprimaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="periodoprimaria_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Periodo"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="certificadoprimaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="certificadoprimaria_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="Si">Si</option>
                        <option value="No">No</option>
                      </select>
                    )}
                  />
                </td>
              </tr>
  
              {/* Secundaria */}
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  SECUNDARIA
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="nombresecundaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="nombresecundaria_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Institución"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="ciudadsecundaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="ciudadsecundaria_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Ciudad"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="aniossecundaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="aniossecundaria_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Años"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="periodosecundaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="periodosecundaria_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Periodo"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="certificadosecundaria_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="certificadosecundaria_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="Si">Si</option>
                        <option value="No">No</option>
                      </select>
                    )}
                  />
                </td>
              </tr>
  
              {/* Bachillerato */}
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  BACHILLERATO
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="nombrebachillerato_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="nombrebachillerato_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Institución"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="ciudadbachillerato_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="ciudadbachillerato_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Ciudad"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="aniosbachillerato_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="aniosbachillerato_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Años"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="periodobachillerato_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="periodobachillerato_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Periodo"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="certificadobachillerato_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="certificadobachillerato_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="Si">Si</option>
                        <option value="No">No</option>
                      </select>
                    )}
                  />
                </td>
              </tr>
  
              {/* Licenciatura */}
              <tr>
                <td className={`border px-4 py-2 ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  LICENCIATURA
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="nombrelicenciatura_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="nombrelicenciatura_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Institución"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="ciudadlicenciatura_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="ciudadlicenciatura_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Ciudad"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="anioslicenciatura_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="anioslicenciatura_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Años"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="periodolicenciatura_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="periodolicenciatura_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Periodo"
                      />
                    )}
                  />
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="certificadolicenciatura_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        id="certificadolicenciatura_se"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      >
                        <option value="">Elige</option>
                        <option value="Si">Si</option>
                        <option value="No">No</option>
                      </select>
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="overflow-x-auto">
          <table className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white border border-gray-300"}`}>
            <tbody>
              {/* Pregunta: ¿Estudia actualmente? */}
              <tr>
                <td className={`border px-4 py-2 font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  ¿Estudia actualmente?
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="estudiaactualmente_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="estudiaactualmente_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Respuesta"
                      />
                    )}
                  />
                </td>
              </tr>
  
              {/* Pregunta: ¿En dónde? */}
              <tr>
                <td className={`border px-4 py-2 font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  ¿En dónde?
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="dondeestudia_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="dondeestudia_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Lugar de estudio"
                      />
                    )}
                  />
                </td>
              </tr>
  
              {/* Pregunta: ¿Horario? */}
              <tr>
                <td className={`border px-4 py-2 font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  ¿Horario?
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="horarioestudio_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="horarioestudio_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Horario de estudio"
                      />
                    )}
                  />
                </td>
              </tr>
  
              {/* Nota adicional */}
              <tr>
                <td className={`border px-4 py-2 font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                  En caso de contar con Carrera Técnica y/o Licenciatura, indicar
                  especialidad.
                </td>
                <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="indicarespecialidad_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="indicarespecialidad_se"
                        type="text"
                        className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        placeholder="Especialidad"
                      />
                    )}
                  />
                </td>
              </tr>
              <tr className={`${isDarkMode ? "text-white" : "text-black"}`}>
                <td colSpan={2} className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                  <Controller
                    name="notaestudio_se"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="notaestudio_se"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                        aria-label="notaestudio_se"
                        placeholder="Nota..."
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  
  


  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
        <form
          onSubmit={handleSubmit((data) => {
            const formData = {
              ...data,
              aniodemanda_se: data.aniodemanda_se || null,
            };

            console.log(data);

            // Primero, enviamos la fecha (como ya lo hacías)
            mutateFechaSE.mutate(
              {
                data: { fecha_evaluacionse: data.fecha_evaluacionse },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  mutateEvaluacionSE.mutate(
                    {
                      data: formData,
                      tipo: "post",
                    },
                    {
                      onSuccess: () => {
                        navigate(`/socioeconomica/${evaluadosList_id}`);
                      },
                      onError: (error) => {
                        console.error("Error al guardar Resultado PS:", error);
                        console.error("Detalles del error:", error.response.data);
                      },
                    }
                  );
                },
                onError: (error) => {
                  console.error("Error al guardar Fecha socioeconomica:", error);
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className="mt-6 p-4 flex justify-between">
            {/* Botón Cancelar */}
            {currentPage === 1 && (
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/socioeconomica/${evaluadosList_id}`);
                }}
                className={`${isDarkMode ? "bg-red-600 hover:bg-red-700" : "bg-red-500 hover:bg-red-600 text-white"}`}
              >
                Cancelar
              </Button>
            )}

            {/* Botón Siguiente */}
            {currentPage === 1 && (
              <button
                type="button"
                className={`rounded px-4 py-2 transition-colors ${isDarkMode ? "bg-blue-600 hover:bg-blue-700 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"}`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage + 1);
                }}
              >
                Siguiente
              </button>
            )}

            {currentPage > 1 && (
              <Button
                color="blue"
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage - 1);
                }}
                className={`${isDarkMode ? "bg-blue-600 hover:bg-blue-700" : "bg-blue-500 hover:bg-blue-600 text-white"}`}
              >
                Anterior
              </Button>
            )}

            {/* Botón Guardar */}
            {currentPage === 2 && (
              <div className="flex space-x-4">
                <button
                  type="submit"
                  className={`rounded px-4 py-2 transition-colors ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
                >
                  Guardar
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
